import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { DeleteToneRequest } from './deletetonerequest';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class DeleteToneAPI extends SixdeeCRBTAPI<DeleteToneRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext)
    {
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/delete-tone
        return "delete-tone";
    }

    getRequestData()
    {
        console.log("--tiger"+this.getRequest().getDeleteToneRequest().getLanguage());
        return "msisdn="+ this.getRequest().getDeleteToneRequest().getMsisdn()+"&"+
               "toneId="+ this.getRequest().getDeleteToneRequest().getToneId()+"&"+
               "packName="+ this.getRequest().getDeleteToneRequest().getPackName()+"&"+
               "language="+ (this.getRequest().getDeleteToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2");
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/deletetone/deletetoneapi.tsx